import { NgModule, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollbarRefDirective } from './scrollbar-ref.directive';
import { OnScrollViewDirective } from './on-scroll-view.directive';
import { IntersectionObserverService } from './intersection-observer.service';
import { ScrollBarService } from './scrollbar.service';

@NgModule({
    imports: [
        CommonModule,
        ScrollbarRefDirective,
        OnScrollViewDirective,
    ],
    exports: [
        ScrollbarRefDirective,
        OnScrollViewDirective
    ],
    providers: [{
            provide: 'OnScrollViewIOS',
            useFactory: (zone: NgZone, scrollBarService: ScrollBarService) => {
                const viewport = new IntersectionObserverService(zone, scrollBarService);
                viewport.setup( /* Main Scrollbar root. */);
                return (viewport);
            },
            deps: [NgZone, ScrollBarService]
        }
    ]
})
export class ScrollModule { }
